module.exports = "<p>events works!</p>\r\n"